import { selectBombBomb, setBombBombOpen, selectBombBombVideo } from '../../../store/slices/bombBomb'
import { useState } from 'react'
import { format } from 'date-fns'
import { HomeUser } from '../../../types/home'
import { Button, Panel } from '../../../Components'
import { flashNotification } from '../../../actions'
import { defineMessages, useIntl } from 'react-intl'
import { useSelector, useDispatch } from 'react-redux'
import { selectHomeData } from '../../../store/selectors/home'
import { selectRouteKey } from '../../../store/selectors/routes'
import { BombBombSendFormBody } from './BombBombSendFormBody'
import { selectBuyerInfo } from '../../../store/selectors/buyerInfo'
import { BombBombSendFormEmail } from './BombBombSendFormEmail'
import { BombBombSendFormSubject } from './BombBombSendFormSubject'

import styles from './BombBombSendForm.module.scss'

export const MSG = defineMessages({
  headline: {
    id: 'BombBomb.form.headline',
    defaultMessage: 'Send your video'
  },
  subject: {
    id: 'BombBomb.form.subject',
    defaultMessage: 'A tip about your {month} Homebot report'
  },
  notification: {
    id: 'BombBomb.form.notification',
    defaultMessage: 'Your video was sent to {email}!'
  },
  body: {
    id: 'BombBomb.form.body',
    defaultMessage:
      'The market is changing rapidly. I have outlined a few great opportunities for you here based on your current situation.'
  },
  send: {
    id: 'BombBomb.send.button',
    defaultMessage: 'Send email'
  }
})

export const BombBombSendForm = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const month = format(new Date(), 'MMMM')
  const home = useSelector(selectHomeData)
  const isHome = selectRouteKey() === 'home'
  const bombBomb = useSelector(selectBombBomb)
  const video = useSelector(selectBombBombVideo)
  const buyerInfo = useSelector(selectBuyerInfo)
  const [loading, setLoading] = useState(false)
  const [body, setBody] = useState(intl.formatMessage(MSG.body))
  const [subject, setSubject] = useState(intl.formatMessage(MSG.subject, { month }))
  const owners = home?.users?.map((u: HomeUser) => u.email).join(', ')
  const [email, setEmail] = useState(isHome ? owners : buyerInfo?.email)

  const handleSendVideoEmail = e => {
    setLoading(true)
    e.preventDefault()

    bombBomb?.videoQuickSend(
      {
        subject: subject,
        video_id: video.videoId,
        email_addresses: email?.replace(/([\s;,]+)/g, '; '),
        mobile_message:
          body + '<br /><br />' + `<a href="${window.location.href}">View your Homebot Report &rsaquo;&rsaquo;</a>`
      },
      () => {
        dispatch(
          flashNotification({
            message: intl.formatMessage(MSG.notification, { email }),
            messageType: 'error'
          })
        )

        dispatch(setBombBombOpen(false))
        setLoading(false)
      }
    )
  }

  return (
    <form className={styles.form} onSubmit={handleSendVideoEmail}>
      <Panel.Heading>{intl.formatMessage(MSG.headline)}</Panel.Heading>
      <BombBombSendFormEmail email={email} setEmail={setEmail} />
      <BombBombSendFormSubject subject={subject} setSubject={setSubject} />
      <BombBombSendFormBody body={body} setBody={setBody} />
      <Button primary type='submit' loading={loading}>
        {intl.formatMessage(MSG.send)}
      </Button>
    </form>
  )
}
